module.exports = __webpack_public_path__ + "img/cardFourImg.737d31fe.png";